var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"row-content",class:_vm.containerClass},[(!_vm.isText)?_c('i',{staticClass:"fa fa-file row-content--side"}):_vm._e(),_c('span',{staticClass:"row-content--main"},[_c('span',{staticClass:"t-500"},[_vm._v(_vm._s(_vm._f("pluralize")('Project',_vm.countProjects))+":")]),_vm._v(" "+_vm._s(_vm.countProjects)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }